import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './water-meter-cold-lg.svg';
import md from './water-meter-cold-md.svg';
import sm from './water-meter-cold-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.WATER_METER_COLD,
  label: 'Kaltwasserzähler',
  shortLabel: 'Kaltwasser',
  icons: { sm, md, lg },
  component: component('water-meter-cold/WaterMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('water-meter-cold/WaterMeterAggregationWidget.vue'),
    props: { digitColor: 'BLUE' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
